import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import {
    Box,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    FormHelperText,
    Paper,
    Typography,
    CircularProgress,
    Chip,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import SubmitButton from "../UI/SubmitButton";
import { useLocation, useParams } from "react-router-dom";
import { setModal } from "../store/modalSlice";
import EntryButton from "../UI/EntryButton";
import { clearUserDetail } from "../store/userSlice";
import { allWarehouseListAction } from "../asyncActions/warhouseActions";
import { branchDetailAction, getBranchAction } from "../asyncActions/branchActions";

function BranchEditPage() {
    const dispatch = useDispatch();
    const {
        branchName,
        branchId,
        isKitchen,
        isArchived,
        dataBranchDetailLoad
    } = useSelector(
        (state) => state.branch
    );

    const {
        branchList,
        dataLoad
    } = useSelector(
        (state) => state.warhouse
    );


    const location = useLocation();
    const { id } = useParams();

    const type = useMemo(() => {
        if (location.pathname.includes("create")) return "create";
        if (location.pathname.includes("edit")) return "edit";
        return "none";
    }, [location.pathname]);

    useEffect(() => {
        dispatch(allWarehouseListAction());

        if (type === "edit") {
            dispatch(branchDetailAction(id));
            return () => dispatch(clearUserDetail());
        }
        return () => reset();
    }, [dispatch, id, type]);

    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        reset,
    } = useForm();

    useEffect(() => {
        if (type === "edit" && branchId) {
            reset({
                name: branchName || "",
                isKitchen: Boolean(isKitchen)
            });
        }
    }, [type, branchId, branchName, isKitchen, reset]);


    const onSubmit = (data) => {
        if (type === "create") {
            const params = {
                name: data.name,
                isKitchen: data.isKitchen,
                source_branch_id: data.buffers
            };
            dispatch(setModal({ active: true, content: "branchCreate", data: params }));
        } else if (type === "edit") {
            const params = {
                id: branchId,
                body: {
                    name: data.name,
                    isKitchen: data.isKitchen,
                },
            };
            dispatch(setModal({ active: true, content: "branchEdit", data: params }));
        }
    };

    const handleDelete = () => {
        dispatch(
            setModal({
                active: true,
                content: "branchArchive",
                data: { isArchived, branchId },
            })
        );
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "25px" }}>
            {dataLoad || dataBranchDetailLoad ? (
                <CircularProgress />
            ) : (
                <>
                    {type === "create" ? (
                        <Typography variant="h5" align="center">
                            Add Branch
                        </Typography>
                    ) : (
                        <Typography variant="h5" align="center">
                            Editting <span style={{ color: "orange" }}>{branchName}</span>
                        </Typography>
                    )}
                    <Paper sx={{ padding: 2, width: "100%", maxWidth: "600px" }}>
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            style={{ display: "flex", flexDirection: "column", gap: "25px" }}
                        >
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "40px",
                                }}
                            >
                                {/* Username */}
                                <TextField
                                    label="Name"
                                    {...register("name", { required: "name is required" })}
                                    error={Boolean(errors.name)}
                                    helperText={errors.name?.message}
                                    fullWidth
                                />

                                <Controller
                                    name="isKitchen"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            label="Kitchen"
                                            control={
                                                <Checkbox
                                                    checked={!!field.value}
                                                    onChange={(e) => field.onChange(e.target.checked)}
                                                />
                                            }
                                        />
                                    )}
                                />

                                {type === 'create' &&
                                    <FormControl fullWidth error={Boolean(errors.buffers)}>
                                        <InputLabel>Copy buffers from branch</InputLabel>
                                        <Controller
                                            name="buffers"
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                    label="Copy buffers from branch"
                                                    value={field.value ?? ""}
                                                    onChange={(e) => {
                                                        field.onChange(Number(e.target.value));
                                                    }}
                                                >
                                                    <MenuItem value={0}>None</MenuItem>
                                                    {branchList && branchList.map(b => <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
                                                </Select>
                                            )}
                                        />
                                        <FormHelperText>{errors.buffers?.message}</FormHelperText>
                                    </FormControl>
                                }
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}
                            >
                                {type === "edit" && (
                                    <EntryButton onClick={handleDelete}>{isArchived ? "Activate" : "Archive"}</EntryButton>
                                )}
                                <SubmitButton type="submit">Save</SubmitButton>
                            </Box>
                        </form>
                    </Paper>
                </>
            )}
        </Box>
    );
}

export default BranchEditPage;
